<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container
          grid-list-xs
          fluid
          class="mb-0 pb-0 pt-3 pr-3"
          style="padding: 5px"
        >
          <v-card-title style="padding: 0">
            <search-field @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->

            <v-btn
              fab
              dark
              small
              color="primary"
              @click="getData"
              style="margin-top: 10px"
            >
              <v-icon dark>play_arrow</v-icon>
            </v-btn>

            <add-button
              v-if="$moduleAccess('add_schedule')"
              @add="openAddDialog"
            ></add-button>

            <!-- <download-button
              :loading="downLoading"
              :disabled="downLoading"
              title="Download"
              @download="downloadTemplate()"
            ></download-button>-->

            <!-- Dialog for Add, View Edit  -->

            <v-container style="padding-bottom: 0" fluid>
              <v-layout wrap class="pa-0">
                <v-flex md2 style="padding: 0 5px">
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFrom"
                      label="Date From"
                      prepend-inner-icon="event"
                      outline
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="dateFrom"
                      :max="dateTo"
                      min="1950-01-01"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md2 style="padding: 0 5px">
                  <v-menu
                    ref="menu1"
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateTo"
                      label="Date To"
                      prepend-inner-icon="event"
                      outline
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="dateTo"
                      :min="dateFrom"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>

          <action-dialog
            :type="dialogType"
            :title="title"
            :dialog="dialogStatus"
            @saveDialog="saveDialog"
            @closeDialog="closeDialog"
            :loading="dialogLoading"
          >
            <v-container grid-list-xs>
              <v-layout justify-center>
                <v-flex md6>
                  <!-- Insert View Dialog Content BELOW-->
                  <details-container
                    ref="detailsRef"
                    :data="viewData"
                    :fareMatrix="fareMatrix"
                    :terminalServers="terminalServers"
                    :readonly="dialogType === 'view'"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </action-dialog>
          <print-dialog
            title="Trip Manifest"
            :dialog="viewDialog"
            @printDialog="savePrintDialog"
            @closeDialog="closeViewDialog"
            :loading="dialogLoading"
          >
            <v-container grid-list-xs>
              <v-layout justify-center>
                <v-flex md6>
                  <!-- Insert View Dialog Content BELOW-->
                  <v-layout
                    justify-center
                    v-for="layout in vehicleLayout"
                    :key="layout.index"
                  >
                    <v-container>
                      <v-layout justify-center>
                        <span>Floor: {{ layout.floor_no }}</span>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex v-for="col in layout.column" :key="col.index">
                          <v-container class="ma-0 pa-0">
                            <v-layout v-for="row in col.data" :key="row.index">
                              <icon-seat
                                v-if="row.status === 0"
                                :pointer="true"
                                :seatName="row.seat_name.toString()"
                                color="#0d72b9"
                              ></icon-seat>
                              <icon-seat
                                v-if="row.status === 3"
                                :pointer="true"
                                :seatName="row.seat_name.toString()"
                                color="gray"
                              ></icon-seat>
                              <icon-seat
                                v-if="row.status === 1"
                                :pointer="true"
                                :seatName="row.seat_name.toString()"
                                color="red"
                              ></icon-seat>
                              <icon-seat
                                v-if="row.status === 2"
                                :pointer="true"
                                :seatName="row.seat_name.toString()"
                                color="red"
                              ></icon-seat>
                              <icon-toilet
                                v-if="row.status === 4"
                              ></icon-toilet>
                              <icon-driver
                                v-if="row.status === 5"
                              ></icon-driver>
                              <icon-blank v-if="row.status === 6"></icon-blank>
                              <icon-door v-if="row.status === 7"></icon-door>
                              <icon-blank v-if="row.status === 8"></icon-blank>
                            </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout justify-end>
                <v-flex md1>
                  <v-spacer></v-spacer>
                  <refresh-button
                    @refresh="openViewDialog(viewData)"
                  ></refresh-button>
                </v-flex>
              </v-layout>
            </v-container>
          </print-dialog>

          <v-dialog
            v-model="assignDialog"
            scrollable
            max-width="300px"
            @keydown.esc="assignDialog = false"
          >
            <v-card>
              <v-card-title>Select Vehicle</v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 300px">
                <v-radio-group v-model="vehicle" column>
                  <v-radio
                    v-for="(vehicle, v) in vehicles"
                    :key="v"
                    color="primary"
                    :label="vehicle.text"
                    :value="vehicle.value"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click="closeAssignDialog()"
                  >Close</v-btn
                >
                <v-btn
                  color="primary"
                  flat
                  :disabled="vehicle === null"
                  @click="saveAssignDialog()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <delete-dialog
            :title="title"
            :type="deleteType"
            :deleteDialog="deleteDialog"
            @saveDeleteDialog="saveDeleteDialog"
            @closeDeleteDialog="closeDeleteDialog"
            :loading="confirmLoading"
          ></delete-dialog>
          <confirm-dialog
            :confirmDialog="openConfirmDialog"
            @saveConfirmDialog="
              dialogType === 'edit'
                ? saveEditDialog()
                : dialogType === 'add'
                ? saveAddDialog()
                : ''
            "
            @closeConfirmDialog="closeConfirmDialog"
            :loading="confirmLoading"
          ></confirm-dialog>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">{{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8></v-flex>
            </v-layout>
          </v-container>

          <filter-panel :openFilter="openFilter">
            <!-- <v-flex md3>
              <v-select
                v-model="filterDepartureDate"
                :items="filterDepartureDates"
                label="By Departure Date"
                solo
                clearable
              ></v-select>
            </v-flex>-->
            <!-- <v-flex md3>
              <v-select
                v-model="filterDepartureTime"
                :items="filterDepartureTimes"
                label="By Departume Time"
                solo
                clearable
            ></v-select>-->
            <!-- </v-flex> -->
            <v-flex md3>
              <v-select
                v-model="filterVehicleLayout"
                :items="filterVehicleLayouts"
                label="By Vehicle Layout"
                solo
                clearable
              ></v-select>
            </v-flex>
            <v-flex md3>
              <v-select
                v-model="filterRoute"
                :items="filterRoutes"
                label="By Route"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-divider></v-divider>
        </v-container>

        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <!-- <td
                  class="text-xs-left text-uppercase"
            >{{ $dateFormat(props.item.departure_date_time,"YYYY-MM-DD") }}</td>-->
            <td class="text-xs-center">{{ props.item.schedule_code }}</td>
            <td class="text-xs-center">
              {{ $dateFormat(props.item.departure_date_time, "MMMM DD, YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $dateFormat(props.item.departure_date_time, "HH:mm") }}
            </td>

            <!-- <td class="text-xs-center">{{ $dateFormat(props.item.created_at,"MMMM DD, YYYY") }}</td> -->
            <!-- <td class="text-xs-center">{{ $dateFormat(props.item.created_at,"HH:mm") }}</td> -->

            <td class="text-xs-left text-uppercase">
              {{
                props.item.fare_matrix === null
                  ? ""
                  : props.item.fare_matrix.vehicle_layout.name
              }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.fare_matrix === null
                  ? ""
                  : props.item.fare_matrix.route.name
              }}
            </td>

            <td class="text-xs-left text-uppercase">
              {{
                props.item.terminal_server
                  ? props.item.terminal_server.name
                  : "--"
              }}
            </td>

            <!-- Add Cell Data BELOW-->
            <td class="text-no-wrap text-xs-center">
              <view-button @view="openViewDialog(props.item)"></view-button>
              <assign-button
                v-if="
                  props.item.status === 0 && $moduleAccess('vehicle_assignment')
                "
                title="Vehicle Assignment"
                @assign="openAssignDialog(props.item)"
              ></assign-button>
              <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->

              <delete-button
                v-if="$moduleAccess('delete_schedule')"
                @delete="openDeleteDialog(props.item)"
              ></delete-button>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import CompanyServices from "@/services/CompanyServices";
import Services from "@/services/SubCompanyServices";
import DetailsContainer from "@/components/details_container/ScheduleDetailsContainer";
import JsPDF from "jspdf";
import moment from "moment";
const now = new Date();

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      openFilter: false,
      filterRoutes: [],
      filterVehicleLayouts: [],
      filterDepartureTimes: [],
      filterDepartureDates: [],
      filterRoute: null,
      filterVehicleLayout: null,
      filterDepartureTime: null,
      filterDepartureDate: null,

      title: "Schedule",

      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Schedule Code",
          align: "center",
          value: "name",
          sortable: false,
        },
        {
          text: "Departure Date",
          align: "center",
          value: "name",
          sortable: false,
        },
        {
          text: "Departure Time",
          align: "center",
          value: "name",
          sortable: false,
        },
        // {
        //   text: "Date Created",
        //   align: "center",
        //   value: "created_at",
        //   sortable: false
        // },
        // {
        //   text: "Time Created",
        //   align: "center",
        //   value: "created_at",
        //   sortable: false
        // },
        {
          text: "Vehicle Layout",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Route",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Terminal Server",
          align: "left",
          value: "terminal_server_id",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      passengerTypeHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
      ],
      items: [],
      passengerTypeItems: [],
      queryParams: {
        search: "",
        date_from: null,
        date_to: null,
        company_id: this.$store.state.company.id,
        sub_company_id: this.$store.state.subcompany.id,
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      assignDialog: false,
      fareMatrix: [],
      vehicles: [],
      terminalServers: [],
      vehicle: null,
      viewDialog: false,
      vehicleLayout: [],
      seats: [],

      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      vehicle_layout_id: null,
    };
  },
  created: function () {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    filterRoute: async function () {
      if (
        this.filterRoute !== null &&
        this.filterRoute !== undefined &&
        this.filterRoute !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.route_id = this.filterRoute;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.route_id = null;
        this.getData();
      }
    },
    filterVehicleLayout: async function () {
      if (
        this.filterVehicleLayout !== null &&
        this.filterVehicleLayout !== undefined &&
        this.filterVehicleLayout !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.vehicle_layout_id = this.filterVehicleLayout;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.vehicle_layout_id = null;
        this.getData();
      }
    },
    filterDepartureTime: async function () {
      if (
        this.filterDepartureTime !== null &&
        this.filterDepartureTime !== undefined &&
        this.filterDepartureTime !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.departure_time = this.filterDepartureTime;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.departure_time = null;
        this.getData();
      }
    },
    filterDepartureDate: async function () {
      if (
        this.filterDepartureDate !== null &&
        this.filterDepartureDate !== undefined &&
        this.filterDepartureDate !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.departure_date = this.filterDepartureDate;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.departure_date = null;
        this.getData();
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      try {
        // Query Data
        let response = (await Services.getSchedules(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        console.log(response);

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getSchedule(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setSeatReservation(id) {
      var data = {};

      try {
        const response = await Services.getSeatReservation(id);
        data = await response.data.data.map((val) => {
          return {
            floor_no: val.floor_no,
            column_no: val.column_no,
            row_no: val.row_no,
            seat_name: val.seat_name,
            status: val.status,
            passenger_detail: val.passenger_detail,
          };
        });
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setFareMatrixs() {
      this.fareMatrix = [];
      const items = (
        await Services.getFareMatrixs({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let seats = [];

        if (el[i].vehicle_layout) {
          seats = el[i].vehicle_layout.seats;
        }

        let data = {
          text: el[i].name.toUpperCase(),
          vehicle_layout: seats,
          value: el[i].id,
        };

        this.fareMatrix.push(data);
      }
    },
    async setTerminalServers() {
      this.terminalServers = [];
      const items = (
        await CompanyServices.getTerminalServers({
          company_id: this.$store.state.company.id,
          is_activated: true,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };

        this.terminalServers.push(data);
      }
    },
    async setVehicles() {
      this.vehicles = [];
      const items = (
        await Services.getVehicles({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          vehicle_layout_id: this.vehicle_layout_id,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].vehicle_no.toUpperCase(),
          value: el[i].vehicle_id,
        };

        this.vehicles.push(data);
      }
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.setFareMatrixs();
      this.setTerminalServers();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openAssignDialog(data) {
      this.dialogType = "assign";
      this.vehicle_layout_id = data.fare_matrix.vehicle_layout_id;

      await this.setVehicles();
      this.viewData = await data;
      this.assignDialog = true;
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.viewDialog = true;
      this.viewData = data;

      const details = await data.fare_matrix.vehicle_layout;

      var layout = [];
      const seats = await this.setSeatReservation(data.id);
      this.seats = (await seats.length) === 0 ? details.seats : seats;

      for (var f = 1; f <= details.floor_count; f++) {
        let data = {
          floor_no: f,
          column: [],
        };
        for (var c = 1; c <= details.column_count; c++) {
          let col = { data: [] };
          for (var s = 0; s < details.seats.length; s++) {
            if (details.seats[s].floor_no === f) {
              if (details.seats[s].column_no === c) {
                var detail = {
                  seat_name: details.seats[s].seat_name,
                  status: details.seats[s].status,
                };
                for (var v = 0; v < seats.length; v++) {
                  if (details.seats[s].floor_no === seats[v].floor_no) {
                    if (details.seats[s].column_no === seats[v].column_no) {
                      if (details.seats[s].row_no === seats[v].row_no) {
                        detail.status = seats[v].status;
                      }
                    }
                  }
                }
                if (details.seats[s].status === 0) {
                  this.viewData.seat_count++;
                }

                col.data.push(await detail);
              }
            }
          }
          data.column.push(col);
        }
        layout.push(data);
      }
      this.vehicleLayout = await layout;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async savePrintDialog() {
      try {
        const response = await Services.printManifest(this.viewData.id);

        if (response.status === 201 || response.status === 204) {
          this.closeViewDialog();

          await this.getData();

          await this.printPdf();

          this.$infoBar({
            type: "success",
            text: "Trip Manifest has been printed!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
    },
    async printPdf() {
      var doc = new JsPDF();

      const data = await this.viewData.fare_matrix.vehicle_layout;

      let y =
        data.column_count === 8
          ? 33
          : data.column_count === 10
          ? 25
          : data.column_count === 11
          ? 23
          : 21;
      let x = data.row_count === 4 ? 53 : data.row_count === 6 ? 32 : 40;

      for (let f = 1; f <= data.floor_count; f++) {
        if (f > 1) {
          doc.addPage();
        }
        doc.setFontSize(12);
        doc.text(this.$store.state.subcompany.name.toUpperCase(), 105, 10, {
          align: "center",
        });
        doc.setFontSize(8);
        doc.setFontStyle("bold");

        doc.text("TRIP MANIFEST", 105, 15, { align: "center" });
        doc.text(
          "TRIP SCHEDULE: " + this.viewData.departure_date_time,
          105,
          20,
          {
            align: "center",
          }
        );

        doc.text("(" + data.vehicle_type.name.toUpperCase() + ")", 105, 25, {
          align: "center",
        });
        doc.setFontSize(8);
        doc.text("FLOOR: " + f, 10, 30);
        for (let a = 1; a <= data.row_count; a++) {
          for (let e = 1; e <= data.column_count; e++) {
            for (var v = 0; v < this.seats.length; v++) {
              if (f === this.seats[v].floor_no) {
                if (a === this.seats[v].row_no) {
                  if (e === this.seats[v].column_no) {
                    if (this.seats[v].status === 0) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        this.seats[v].seat_name,
                        37 + (a - 1) * x,
                        274 - (e - 1) * y,
                        {
                          align: "right",
                        }
                      );
                    } else if (this.seats[v].status === 1) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        this.seats[v].seat_name,
                        37 + (a - 1) * x,
                        274 - (e - 1) * y,
                        {
                          align: "right",
                        }
                      );
                    } else if (this.seats[v].status === 2) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        this.seats[v].seat_name,
                        37 + (a - 1) * x,
                        274 - (e - 1) * y,
                        {
                          align: "right",
                        }
                      );
                      doc.setFontSize(7);

                      doc.text(
                        this.seats[v].passenger_detail.km_post.post.toString(),
                        13 + (a - 1) * x,
                        274 - (e - 1) * y,
                        {
                          align: "left",
                        }
                      );
                      doc.text(
                        this.seats[v].passenger_detail.reference_no,
                        13 + (a - 1) * x,
                        278 - (e - 1) * y,
                        {
                          align: "left",
                        }
                      );
                      doc.text(
                        this.seats[v].passenger_detail.passenger_detail
                          .first_name +
                          " " +
                          this.seats[v].passenger_detail.passenger_detail
                            .last_name,
                        13 + (a - 1) * x,
                        282 - (e - 1) * y,
                        {
                          align: "left",
                        }
                      );
                    } else if (this.seats[v].status === 3) {
                      doc.setFillColor(128, 128, 128);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        this.seats[v].seat_name,
                        37 + (a - 1) * x,
                        274 - (e - 1) * y,
                        {
                          align: "right",
                        }
                      );
                    } else if (this.seats[v].status === 4) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        "RESTROOM",
                        25 + (a - 1) * x,
                        278 - (e - 1) * y,
                        {
                          align: "center",
                        }
                      );
                    } else if (this.seats[v].status === 5) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(12);
                      doc.text("DRIVER", 25 + (a - 1) * x, 278 - (e - 1) * y, {
                        align: "center",
                      });
                    } else if (this.seats[v].status === 7) {
                      doc.setFillColor(255, 255, 255);
                      doc.rect(
                        10 + (a - 1) * x,
                        270 - (e - 1) * y,
                        30,
                        15,
                        "DF"
                      );
                      doc.setFontSize(8);
                      doc.text(
                        "ENTRANCE / EXIT",
                        25 + (a - 1) * x,
                        278 - (e - 1) * y,
                        {
                          align: "center",
                        }
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }

      doc.save("trip_manifest.pdf");

      // doc.setProperties({
      //   title: `${this.viewData.fare_matrix.route.name}_${this.$dateFormat(
      //     this.viewData.departure_date_time,
      //     "YYYYMMDD_HHmm"
      //   )}`
      // });
      // await doc.autoPrint();

      // doc.output("dataurlnewwindow");
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          dates: data.dates,
          fare_matrix_id: data.fare_matrix.value,
          terminal_server_id: data.terminal_server_id,
          seats: data.fare_matrix.vehicle_layout,
          sub_company_id: this.$store.state.subcompany.id,
        };

      try {
        const response = await Services.addSchedule(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Schedule has been added!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveAssignDialog() {
      const body = {
        vehicle_id: this.vehicle,
      };

      try {
        const response = await Services.assignScheduletoVehicle(
          this.viewData.id,
          body
        );

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAssignDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Schedule has been assigned to vehicle!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeAssignDialog();

        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            if (error.response.data.message === "Vehicle already Assigned") {
              this.$infoBar({
                type: "error",
                text: "Vehicle already assigned!",
              });
            }
          }
        }
      }
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          id: data.id,
          name: data.name,
          code: data.code,
        };

      try {
        const response = await Services.editSchedule(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Schedule has been updated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteSchedule(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Schedule has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            if (error.response.data.message === "schedule is reserved!") {
              this.closeDeleteDialog();
              this.$infoBar({
                type: "error",
                text: "This schedule is Reserved",
              });
            }
          }
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeViewDialog() {
      this.viewDialog = false;
    },
    closeAssignDialog() {
      this.vehicle = null;
      this.assignDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      //   await this.setFilterDepartureDates();
      //   await this.setFilterDepartureTimes();

      await this.setFilterVehicleLayouts();
      await this.setFilterRoutes();
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.passengerTypeItems.slice();
    },
    async refreshTable() {
      this.$refs.searchRef.clear();
      this.filterDepartureDate = await null;
      this.filterDepartureTime = await null;
      this.filterVehicleLayout = await null;
      this.filterRoute = await null;
      await this.getData();
    },
    async setFilterDepartureDates() {
      function dateFormat(data, format) {
        let now = null;
        if (data) {
          now = moment(data).format(format);
        } else {
          now = moment(new Date()).format(format);
        }

        return now;
      }
      let data = (
        await Services.getSchedules({
          limit: this.totalItems,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;

      let departDates = data.data;
      let ddArray = [];

      departDates.forEach((date) => {
        // let dateOutcome = dateFormat(date.departure_date_time, "YYYY-MM-DD");
        let dateOutcome = dateFormat(date.departure_date_time, "MMMM DD, YYYY");
        ddArray.push(dateOutcome);
      });

      let unique = [...new Set(ddArray)];

      unique.forEach((theDate) => {
        const body = {
          text: theDate,
          value: theDate,
        };
        this.filterDepartureDates.push(body);
      });
    },
    async setFilterDepartureTimes() {
      function timeFormat(data, format) {
        let now = null;
        if (data) {
          now = moment(data).format(format);
        } else {
          now = moment(new Date()).format(format);
        }

        return now;
      }
      let data = (
        await Services.getSchedules({
          limit: this.totalItems,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;

      let departTimes = data.data;
      let dtArray = [];

      departTimes.forEach((time) => {
        let timeOutcome = timeFormat(time.departure_date_time, "HH:mm");
        dtArray.push(timeOutcome);
      });

      let unique = [...new Set(dtArray)];

      unique.forEach((theTime) => {
        const body = {
          text: theTime,
          value: theTime,
        };
        this.filterDepartureTimes.push(body);
      });
    },
    async setFilterVehicleLayouts() {
      let data = (
        await Services.getSchedules({
          limit: this.totalItems,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;

      let vehLayouts = data.data;

      let vehLayoutsArr = [];

      vehLayouts.forEach((vehLayout) => {
        let body = {
          text: vehLayout.fare_matrix.vehicle_layout.name.toUpperCase(),
          value: vehLayout.fare_matrix.vehicle_layout_id,
        };
        vehLayoutsArr.push(body);
      });

      function removeDuplicates(arr, prop) {
        let obj = {};
        return Object.keys(
          arr.reduce((prev, next) => {
            if (!obj[next[prop]]) obj[next[prop]] = next;
            return obj;
          }, obj)
        ).map((i) => obj[i]);
      }

      removeDuplicates(vehLayoutsArr, "value").forEach((item) => {
        this.filterVehicleLayouts.push(item);
      });
    },
    async setFilterRoutes() {
      let data = (
        await Services.getSchedules({
          limit: this.totalItems,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data;

      let theRoutes = data.data;

      let theRoutesArr = [];

      theRoutes.forEach((theRoute) => {
        let body = {
          text: theRoute.fare_matrix.route.name.toUpperCase(),
          value: theRoute.fare_matrix.route_id,
        };
        theRoutesArr.push(body);
      });

      function removeDuplicates(arr, prop) {
        let obj = {};
        return Object.keys(
          arr.reduce((prev, next) => {
            if (!obj[next[prop]]) obj[next[prop]] = next;
            return obj;
          }, obj)
        ).map((i) => obj[i]);
      }

      removeDuplicates(theRoutesArr, "value").forEach((item) => {
        this.filterRoutes.push(item);
      });
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
